import { Injectable } from '@angular/core'
import { Violence, ViolenceType } from '../../models/violence.interface'
import { Observable } from 'rxjs'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { OptionSelect } from '../../containers/search/search.component'
import { Pagination } from '../../models/pagination.interface'

@Injectable({
    providedIn: 'root',
})
export class ViolenceService {
    constructor(private http: HttpClient) {}

    urlPath = environment.service_1 + 'violence-type-all/'

    httpOptions = {
        headers: new HttpHeaders({}),
    }

    getOptionViolenceType(violenceType: ViolenceType[]): OptionSelect[] {
        return violenceType.map((item: ViolenceType) => {
            return {
                value: item.id ?? '',
                label: item.name ?? '',
            }
        })
    }

    getViolenceType(): Observable<ViolenceType[]> {
        return this.http.get<ViolenceType[]>(this.urlPath, {
            headers: this.httpOptions.headers,
        })
    }
}
